/*
 * @Author: xiwl
 * @Date: 2021-11-08 09:39:32
 * @LastEditors: xiwl
 * @LastEditTime: 2022-04-06 10:08:05
 * @Descripttion: file content
 */
import React from 'react';
import { HashRouter, Route, Switch } from "react-router-dom";
import routers from "./router";
import './App.css';

function App() {
    return <div className="App">
        <HashRouter>
            <Switch>
                {
                    routers.map(router=>{
                        return <Route exact path={router.path} component = { router.component }></Route>
                    })
                }
            </Switch>
        </HashRouter>
    </div>
}

export default App;
